import React from 'react'
import YumSelect, { YumSelectProps } from '../YumSelect/YumSelect'
import Autocomplete from '@material-ui/lab/Autocomplete'
import YumField from '../YumInput/YumInput'
import { t } from 'ttag'
import { SelectInputProps } from '@material-ui/core/Select/SelectInput'
import { DivisionDto } from '../../services/api.types'

import { ReactComponent as GroupActiveIcon } from '../../assets/v3/icons/group-active.svg'
import { ReactComponent as GroupInactiveIcon } from '../../assets/v3/icons/group-inactive.svg'

interface YumCountrySelectProps extends YumSelectProps {
  companyDivisions: DivisionDto[]
  required?: boolean

  onChange?: SelectInputProps['onChange']
  value?: unknown
  error?: any
  label?: any
  style?: any
  ref?: any

  startIcon?: any
  startInactiveIcon?: any

  showIcon?: boolean
  useAutocompleteSelect?: boolean
}

export default function YumTeamSelect({
  companyDivisions,
  required,
  value,
  showIcon,
  useAutocompleteSelect,
  ...props
}: YumCountrySelectProps) {
  const { ref, ...otherProps } = props

  return useAutocompleteSelect ? (
    <Autocomplete
      clearText={t`Clear`}
      closeText={t`Close`}
      openText={t`Open`}
      noOptionsText={t`No options`}
      openOnFocus
      onChange={(event, newValue) => {
        // @ts-ignore
        props.onChange?.({ target: { value: newValue?.id } }, null)
      }}
      options={companyDivisions}
      value={companyDivisions.find((d) => d.id === value) || null}
      getOptionLabel={(option) => option.name}
      getOptionSelected={(option, value) => option.id === value.id}
      renderInput={(params) => (
        <YumField
          {...params}
          label={props.label}
          style={props.style}
          startIcon={showIcon && GroupActiveIcon}
          startIconInactive={showIcon && GroupInactiveIcon}
          value={value}
          error={props.error}
          variant="filled"
          InputProps={{
            ...params.InputProps,
            disableUnderline: true,
            // This disables the browser autocomplete.
            autoComplete: 'new-password',
          }}
          fullWidth={true}
          type="text"
        />
      )}
    />
  ) : (
    <YumSelect
      {...otherProps}
      value={value}
      startIcon={showIcon && GroupActiveIcon}
      startInactiveIcon={showIcon && GroupInactiveIcon}
    >
      {required ? '' : <option value="" />}
      {companyDivisions.map((division, keyIndex) => (
        <option key={keyIndex} value={division.id || ''}>
          {division.name}
        </option>
      ))}
    </YumSelect>
  )
}
